import { API_BASE_URL, USER_LOGIN_CHECK_TIMEOUT } from "config";
import AuthService from "./AuthService";
import { Button, Dimmer, Loader, Modal } from "semantic-ui-react";
import { debounce } from "lodash";
import React, { Component } from "react";
import ServiceBase from "../../ServiceBase";

export default function InactivityChecker(PageClass) {
  const Auth = new AuthService(API_BASE_URL);

  return class InactivityChecker extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isLoading: false,
        openModal: ServiceBase.openInactivityModal,
      };

      // React binding
      this.handleLogout = this.handleLogout.bind(this);
      this.handleRefresh = this.handleRefresh.bind(this);
    }

    componentDidMount() {
      // Turn off any loading signs
      this.setState({
        isLoading: false,
      });

      // Check if the modal should open
      this.debounceModalCheck = debounce(this.checkIfModalShouldOpen, USER_LOGIN_CHECK_TIMEOUT);
      this.debounceModalCheck();
    }

    componentWillUnmount() {
      // Turn off any loading signs
      this.setState({
        isLoading: false,
      });

      // User is on a page that isn't login protected
      this.debounceModalCheck.cancel();
    }

    checkIfModalShouldOpen() {
      // Check if the modal should be opened
      if (this.state.openModal !== ServiceBase.openInactivityModal) {
        // Only setting the state when there is a change will reduce browser usage
        this.setState({
          openModal: ServiceBase.openInactivityModal,
        });
      }
      this.debounceModalCheck();
    }

    handleLogout() {
      // Mark that we are loading
      this.setState({
        isLoading: true,
      });

      // Handle logout
      Auth.logout();

      // Close modal
      ServiceBase.openInactivityModal = false;
      this.setState({
        isLoading: false,
        openModal: false,
      });
    }

    async handleRefresh() {
      // Mark that we are loading
      this.setState({
        isLoading: true,
      });

      // Passing null token to force rechecking the token. Will mean we don't "refresh" when the token has expired, even if the user clicks OK.
      await Auth.refreshToken(null, true);

      // Close modal
      ServiceBase.openInactivityModal = false;
      this.setState({
        isLoading: false,
        openModal: false,
      });
    }

    render() {
      const { isLoading, openModal } = this.state;

      return (
        <>
          <Modal open={openModal ?? false}>
            <Modal.Header>Still there?</Modal.Header>
            <Modal.Content>
              <Modal.Description>
                <Dimmer active={isLoading ?? false} inverted>
                  <Loader inverted />
                </Dimmer>
                You've been logged in awhile. Would you like to remain logged in?
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button color="red" onClick={this.handleLogout}>Log me out</Button>
              <Button color="green" onClick={this.handleRefresh}>Remain logged in</Button>
            </Modal.Actions>
          </Modal>
          <PageClass {...this.props} />
        </>
      );
    }
  }
}
